import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

export const resources = {
  en: {
    translation: {
      'landing.category': 'Product Ad Maker',
      // Channel-neutral on purpose: WhatsApp Status is only the leading hook in
      // some markets (see the market table in the store-metadata ads strategy),
      // and the keyword itself lives in the index.html meta description and the
      // App Store keywords field rather than in visible copy.
      'landing.hero.headline': 'Stunning product photos for your posts, stories & ads.',
      'landing.hero.subheadline': 'Snap a photo, say what you want — get a scroll-stopping post in seconds.',
      'landing.hero.supporting': 'Free to start · No design skills needed',
      'landing.hero.appStore': 'Download on the App Store',
      'landing.hero.googlePlay': 'Get it on Google Play',
      'landing.hero.scanQr': 'Scan to get the app',
      'landing.hero.continueOnWeb': 'Or continue on the web',
      // Button label, shown twice (header + hero store row): title case reads
      // as a peer of "App Store" / "Google Play" beside it.
      'landing.hero.openWebApp': 'Open Web App',
      'landing.hero.worksInBrowser': 'Works in your browser',
      'landing.hero.voicePrompt': 'Make it look premium, add $45',
      // Shown in the price pill on the hero mockup; keep the amount in sync
      // with voicePrompt (the voice bubble "adds" this exact price tag).
      'landing.hero.priceTag': '$45',
      'landing.hero.beforeLabel': 'Before',
      'landing.hero.afterLabel': 'After',
      'landing.hero.mockAlt': 'A before and after product photo made with Peckle',
      'terms.title': 'Terms of Service',
      'terms.lastUpdated': 'Last updated: {{date}}',
      'privacy.title': 'Privacy Policy',
      'privacy.lastUpdated': 'Last updated: {{date}}',
      'deleteAccount.title': 'Delete Your Account',
      'checkout.success.title': 'Payment successful',
      'checkout.success.message': 'Thanks! Your payment went through. Your credits will appear in the Peckle app in a moment.',
      'checkout.success.closeHint': 'You can close this window and return to the app.',
      'referral.badge': 'A gift from a friend',
      'referral.headline': 'Get {{days}} days of watermark-free product photos',
      'referral.subheadline': "Download Peckle and use your friend's code to unlock watermark-free images for both of you.",
      'referral.codeLabel': 'Your invite code',
      'referral.copy': 'Copy',
      'referral.copied': 'Copied!',
      'referral.manualHint': 'On iPhone: install Peckle, then open Settings → Enter referral code and paste this code.',
      'referral.invalidHeadline': 'This invite link looks off',
      'referral.invalidSubheadline': 'You can still get Peckle for free and start creating product photos in seconds.',
      'footer.copyright': '© {{year}} Peckle. All rights reserved.',
      'footer.disclaimer': 'Peckle is not affiliated with WhatsApp, Instagram, Facebook, or TikTok. All trademarks belong to their respective owners.',
      'footer.terms': 'Terms',
      'footer.privacy': 'Privacy',
    },
  },
  fr: {
    translation: {
      'landing.category': 'Créateur de publicités produit',
      'landing.hero.headline': 'De superbes photos produit pour vos posts, stories et pubs.',
      'landing.hero.subheadline': 'Prenez une photo, dites ce que vous voulez — obtenez une publication accrocheuse en quelques secondes.',
      'landing.hero.supporting': 'Gratuit pour commencer · Aucune compétence en design',
      'landing.hero.appStore': 'Télécharger sur l’App Store',
      'landing.hero.googlePlay': 'Disponible sur Google Play',
      'landing.hero.scanQr': 'Scannez pour obtenir l’app',
      'landing.hero.continueOnWeb': 'Ou continuer sur le web',
      'landing.hero.openWebApp': 'Ouvrir l’app web',
      'landing.hero.worksInBrowser': 'Fonctionne dans votre navigateur',
      'landing.hero.voicePrompt': 'Rends-la haut de gamme, ajoute 45 €',
      'landing.hero.priceTag': '45 €',
      'landing.hero.beforeLabel': 'Avant',
      'landing.hero.afterLabel': 'Après',
      'landing.hero.mockAlt': 'Une photo produit avant et après créée avec Peckle',
      'terms.title': 'Conditions d’utilisation',
      'terms.lastUpdated': 'Dernière mise à jour : {{date}}',
      'privacy.title': 'Politique de confidentialité',
      'privacy.lastUpdated': 'Dernière mise à jour : {{date}}',
      'deleteAccount.title': 'Supprimer votre compte',
      'checkout.success.title': 'Paiement réussi',
      'checkout.success.message': 'Merci ! Votre paiement a bien été effectué. Vos crédits apparaîtront dans l’application Peckle dans un instant.',
      'checkout.success.closeHint': 'Vous pouvez fermer cette fenêtre et revenir à l’application.',
      'referral.badge': 'Un cadeau d’un ami',
      'referral.headline': 'Profitez de {{days}} jours de photos produit sans filigrane',
      'referral.subheadline': 'Téléchargez Peckle et utilisez le code de votre ami pour débloquer des images sans filigrane pour vous deux.',
      'referral.codeLabel': 'Votre code d’invitation',
      'referral.copy': 'Copier',
      'referral.copied': 'Copié !',
      'referral.manualHint': 'Sur iPhone : installez Peckle, puis ouvrez Réglages → Saisir un code de parrainage et collez ce code.',
      'referral.invalidHeadline': 'Ce lien d’invitation semble invalide',
      'referral.invalidSubheadline': 'Vous pouvez quand même obtenir Peckle gratuitement et créer des photos produit en quelques secondes.',
      'footer.copyright': '© {{year}} Peckle. Tous droits réservés.',
      'footer.disclaimer': 'Peckle n’est pas affilié à WhatsApp, Instagram, Facebook ou TikTok. Toutes les marques appartiennent à leurs propriétaires respectifs.',
      'footer.terms': 'Conditions',
      'footer.privacy': 'Confidentialité',
    },
  },
  de: {
    translation: {
      'landing.category': 'Produktanzeigen-Maker',
      'landing.hero.headline': 'Beeindruckende Produktfotos für deine Posts, Stories und Anzeigen.',
      'landing.hero.subheadline': 'Foto aufnehmen, sagen, was du willst — in Sekunden ist dein Post fertig.',
      'landing.hero.supporting': 'Kostenlos starten · Keine Designkenntnisse nötig',
      'landing.hero.appStore': 'Im App Store laden',
      'landing.hero.googlePlay': 'Bei Google Play holen',
      'landing.hero.scanQr': 'Scannen und App laden',
      'landing.hero.continueOnWeb': 'Oder im Web fortfahren',
      'landing.hero.openWebApp': 'Web-App öffnen',
      'landing.hero.worksInBrowser': 'Läuft in deinem Browser',
      'landing.hero.voicePrompt': 'Mach es hochwertig, füge 45 € hinzu',
      'landing.hero.priceTag': '45 €',
      'landing.hero.beforeLabel': 'Vorher',
      'landing.hero.afterLabel': 'Nachher',
      'landing.hero.mockAlt': 'Ein Vorher-Nachher-Produktfoto von Peckle',
      'terms.title': 'Nutzungsbedingungen',
      'terms.lastUpdated': 'Zuletzt aktualisiert: {{date}}',
      'privacy.title': 'Datenschutzrichtlinie',
      'privacy.lastUpdated': 'Zuletzt aktualisiert: {{date}}',
      'deleteAccount.title': 'Konto löschen',
      'checkout.success.title': 'Zahlung erfolgreich',
      'checkout.success.message': 'Danke! Deine Zahlung war erfolgreich. Deine Credits erscheinen gleich in der Peckle-App.',
      'checkout.success.closeHint': 'Du kannst dieses Fenster schließen und zur App zurückkehren.',
      'referral.badge': 'Ein Geschenk von einem Freund',
      'referral.headline': 'Sichere dir {{days}} Tage Produktfotos ohne Wasserzeichen',
      'referral.subheadline': 'Lade Peckle herunter und nutze den Code deines Freundes — ihr beide erhaltet Bilder ohne Wasserzeichen.',
      'referral.codeLabel': 'Dein Einladungscode',
      'referral.copy': 'Kopieren',
      'referral.copied': 'Kopiert!',
      'referral.manualHint': 'Auf dem iPhone: Peckle installieren, dann Einstellungen → Empfehlungscode eingeben öffnen und diesen Code einfügen.',
      'referral.invalidHeadline': 'Dieser Einladungslink scheint ungültig',
      'referral.invalidSubheadline': 'Du kannst Peckle trotzdem kostenlos holen und in Sekunden Produktfotos erstellen.',
      'footer.copyright': '© {{year}} Peckle. Alle Rechte vorbehalten.',
      'footer.disclaimer': 'Peckle steht in keiner Verbindung zu WhatsApp, Instagram, Facebook oder TikTok. Alle Marken gehören ihren jeweiligen Inhabern.',
      'footer.terms': 'Bedingungen',
      'footer.privacy': 'Datenschutz',
    },
  },
  es: {
    translation: {
      'landing.category': 'Creador de anuncios de producto',
      'landing.hero.headline': 'Fotos de producto espectaculares para tus publicaciones, stories y anuncios.',
      'landing.hero.subheadline': 'Toma una foto, di lo que quieres y consigue una publicación llamativa en segundos.',
      'landing.hero.supporting': 'Empieza gratis · No necesitas saber diseño',
      'landing.hero.appStore': 'Descargar en el App Store',
      'landing.hero.googlePlay': 'Disponible en Google Play',
      'landing.hero.scanQr': 'Escanea para descargar la app',
      'landing.hero.continueOnWeb': 'O continúa en la web',
      'landing.hero.openWebApp': 'Abrir app web',
      'landing.hero.worksInBrowser': 'Funciona en tu navegador',
      'landing.hero.voicePrompt': 'Haz que se vea premium, añade $45',
      'landing.hero.priceTag': '$45',
      'landing.hero.beforeLabel': 'Antes',
      'landing.hero.afterLabel': 'Después',
      'landing.hero.mockAlt': 'Una foto de producto antes y después creada con Peckle',
      'terms.title': 'Términos de servicio',
      'terms.lastUpdated': 'Última actualización: {{date}}',
      'privacy.title': 'Política de privacidad',
      'privacy.lastUpdated': 'Última actualización: {{date}}',
      'deleteAccount.title': 'Eliminar tu cuenta',
      'checkout.success.title': 'Pago realizado',
      'checkout.success.message': '¡Gracias! Tu pago se procesó correctamente. Tus créditos aparecerán en la app de Peckle en un momento.',
      'checkout.success.closeHint': 'Puedes cerrar esta ventana y volver a la app.',
      'referral.badge': 'Un regalo de un amigo',
      'referral.headline': 'Consigue {{days}} días de fotos de producto sin marca de agua',
      'referral.subheadline': 'Descarga Peckle y usa el código de tu amigo para desbloquear imágenes sin marca de agua para ambos.',
      'referral.codeLabel': 'Tu código de invitación',
      'referral.copy': 'Copiar',
      'referral.copied': '¡Copiado!',
      'referral.manualHint': 'En iPhone: instala Peckle, abre Ajustes → Introducir código de invitación y pega este código.',
      'referral.invalidHeadline': 'Este enlace de invitación no parece válido',
      'referral.invalidSubheadline': 'Aun así puedes descargar Peckle gratis y crear fotos de producto en segundos.',
      'footer.copyright': '© {{year}} Peckle. Todos los derechos reservados.',
      'footer.disclaimer': 'Peckle no está afiliado a WhatsApp, Instagram, Facebook ni TikTok. Todas las marcas pertenecen a sus respectivos propietarios.',
      'footer.terms': 'Términos',
      'footer.privacy': 'Privacidad',
    },
  },
  hi: {
    translation: {
      'landing.category': 'Product Ad Maker',
      'landing.hero.headline': 'आपके posts, stories और ads के लिए शानदार product photos.',
      'landing.hero.subheadline': 'Photo लें, बताएं क्या चाहिए — सेकंडों में scroll-stopping post तैयार।',
      'landing.hero.supporting': 'Free में शुरू करें · Design skills की जरूरत नहीं',
      'landing.hero.appStore': 'App Store से डाउनलोड करें',
      'landing.hero.googlePlay': 'Google Play पर पाएँ',
      'landing.hero.scanQr': 'ऐप पाने के लिए स्कैन करें',
      'landing.hero.continueOnWeb': 'या web पर जारी रखें',
      'landing.hero.openWebApp': 'वेब ऐप खोलें',
      'landing.hero.worksInBrowser': 'Browser में चलता है',
      'landing.hero.voicePrompt': 'इसे premium बनाओ, ₹3,499 जोड़ो',
      'landing.hero.priceTag': '₹3,499',
      'landing.hero.beforeLabel': 'पहले',
      'landing.hero.afterLabel': 'बाद में',
      'landing.hero.mockAlt': 'Peckle से बनी before और after product photo',
      'terms.title': 'सेवा की शर्तें',
      'terms.lastUpdated': 'अंतिम अपडेट: {{date}}',
      'privacy.title': 'गोपनीयता नीति',
      'privacy.lastUpdated': 'अंतिम अपडेट: {{date}}',
      'deleteAccount.title': 'अपना खाता हटाएँ',
      'checkout.success.title': 'Payment सफल',
      'checkout.success.message': 'धन्यवाद! आपका payment हो गया है। आपके credits कुछ ही पलों में Peckle app में दिखेंगे।',
      'checkout.success.closeHint': 'आप यह window बंद करके app पर वापस जा सकते हैं।',
      'referral.badge': 'दोस्त की ओर से एक तोहफ़ा',
      'referral.headline': '{{days}} दिनों की watermark-free product photos पाएं',
      'referral.subheadline': 'Peckle डाउनलोड करें और अपने दोस्त का code इस्तेमाल करें — आप दोनों को watermark-free images मिलेंगी।',
      'referral.codeLabel': 'आपका invite code',
      'referral.copy': 'Copy करें',
      'referral.copied': 'Copy हो गया!',
      'referral.manualHint': 'iPhone पर: Peckle install करें, फिर Settings → रेफ़रल कोड डालें खोलकर यह code paste करें।',
      'referral.invalidHeadline': 'यह invite link सही नहीं लग रहा',
      'referral.invalidSubheadline': 'आप फिर भी Peckle free में पा सकते हैं और सेकंडों में product photos बना सकते हैं।',
      'footer.copyright': '© {{year}} Peckle। सभी अधिकार सुरक्षित।',
      'footer.disclaimer': 'Peckle का WhatsApp, Instagram, Facebook या TikTok से कोई संबंध नहीं है। सभी trademarks उनके संबंधित मालिकों के हैं।',
      'footer.terms': 'शर्तें',
      'footer.privacy': 'गोपनीयता',
    },
  },
  ja: {
    translation: {
      'landing.category': '商品広告メーカー',
      'landing.hero.headline': '投稿、ストーリーズ、広告に映える商品写真。',
      'landing.hero.subheadline': '写真を撮って、希望を言うだけ。数秒で目を引く投稿に。',
      'landing.hero.supporting': '無料で開始 · デザインスキル不要',
      'landing.hero.appStore': 'App Storeでダウンロード',
      'landing.hero.googlePlay': 'Google Playで入手',
      'landing.hero.scanQr': 'スキャンしてアプリを入手',
      'landing.hero.continueOnWeb': 'またはウェブ版で続ける',
      'landing.hero.openWebApp': 'ウェブ版を開く',
      'landing.hero.worksInBrowser': 'ブラウザで使えます',
      'landing.hero.voicePrompt': '高級感を出して、¥6,800を追加',
      'landing.hero.priceTag': '¥6,800',
      'landing.hero.beforeLabel': '加工前',
      'landing.hero.afterLabel': '加工後',
      'landing.hero.mockAlt': 'Peckleで作成した商品写真のビフォーアフター',
      'terms.title': '利用規約',
      'terms.lastUpdated': '最終更新: {{date}}',
      'privacy.title': 'プライバシーポリシー',
      'privacy.lastUpdated': '最終更新: {{date}}',
      'deleteAccount.title': 'アカウントを削除',
      'checkout.success.title': 'お支払いが完了しました',
      'checkout.success.message': 'ありがとうございます。お支払いが完了しました。クレジットはまもなくPeckleアプリに反映されます。',
      'checkout.success.closeHint': 'このウィンドウを閉じてアプリにお戻りください。',
      'referral.badge': '友達からのギフト',
      'referral.headline': 'ウォーターマークなしの商品写真を{{days}}日間',
      'referral.subheadline': 'Peckleをダウンロードして友達のコードを使うと、2人ともウォーターマークなしの画像が使えます。',
      'referral.codeLabel': 'あなたの招待コード',
      'referral.copy': 'コピー',
      'referral.copied': 'コピーしました！',
      'referral.manualHint': 'iPhoneの場合: Peckleをインストールし、設定 → 紹介コードを入力からこのコードを貼り付けてください。',
      'referral.invalidHeadline': 'この招待リンクは無効のようです',
      'referral.invalidSubheadline': 'それでもPeckleは無料で使えて、数秒で商品写真を作成できます。',
      'footer.copyright': '© {{year}} Peckle. All rights reserved.',
      'footer.disclaimer': 'PeckleはWhatsApp、Instagram、Facebook、TikTokと提携していません。すべての商標はそれぞれの所有者に帰属します。',
      'footer.terms': '規約',
      'footer.privacy': 'プライバシー',
    },
  },
  pt: {
    translation: {
      'landing.category': 'Criador de anúncios de produto',
      'landing.hero.headline': 'Fotos de produto incríveis para seus posts, Stories e anúncios.',
      'landing.hero.subheadline': 'Tire uma foto, diga o que quer — e receba um post que chama atenção em segundos.',
      'landing.hero.supporting': 'Comece grátis · Não precisa saber design',
      'landing.hero.appStore': 'Baixar na App Store',
      'landing.hero.googlePlay': 'Disponível no Google Play',
      'landing.hero.scanQr': 'Escaneie para baixar o app',
      'landing.hero.continueOnWeb': 'Ou continue pela web',
      'landing.hero.openWebApp': 'Abrir app web',
      'landing.hero.worksInBrowser': 'Funciona no navegador',
      'landing.hero.voicePrompt': 'Deixa com cara premium e coloca R$ 199',
      'landing.hero.priceTag': 'R$ 199',
      'landing.hero.beforeLabel': 'Antes',
      'landing.hero.afterLabel': 'Depois',
      'landing.hero.mockAlt': 'Uma foto de produto antes e depois criada com o Peckle',
      'terms.title': 'Termos de serviço',
      'terms.lastUpdated': 'Última atualização: {{date}}',
      'privacy.title': 'Política de privacidade',
      'privacy.lastUpdated': 'Última atualização: {{date}}',
      'deleteAccount.title': 'Excluir sua conta',
      'checkout.success.title': 'Pagamento concluído',
      'checkout.success.message': 'Obrigado! Seu pagamento foi aprovado. Seus créditos vão aparecer no app Peckle em instantes.',
      'checkout.success.closeHint': 'Você pode fechar esta janela e voltar para o app.',
      'referral.badge': 'Um presente de um amigo',
      'referral.headline': "Ganhe {{days}} dias de fotos de produto sem marca d'água",
      'referral.subheadline': "Baixe o Peckle e use o código do seu amigo para desbloquear imagens sem marca d'água para vocês dois.",
      'referral.codeLabel': 'Seu código de convite',
      'referral.copy': 'Copiar',
      'referral.copied': 'Copiado!',
      'referral.manualHint': 'No iPhone: instale o Peckle, abra Ajustes → Inserir código de indicação e cole este código.',
      'referral.invalidHeadline': 'Este link de convite parece inválido',
      'referral.invalidSubheadline': 'Você ainda pode baixar o Peckle grátis e criar fotos de produto em segundos.',
      'footer.copyright': '© {{year}} Peckle. Todos os direitos reservados.',
      'footer.disclaimer': 'O Peckle não é afiliado ao WhatsApp, Instagram, Facebook ou TikTok. Todas as marcas pertencem aos seus respectivos proprietários.',
      'footer.terms': 'Termos',
      'footer.privacy': 'Privacidade',
    },
  },
  ru: {
    translation: {
      'landing.category': 'Создатель рекламы товаров',
      'landing.hero.headline': 'Эффектные фото товаров для постов, Stories и рекламы.',
      'landing.hero.subheadline': 'Сфотографируйте товар, скажите, что нужно — заметный пост будет готов за секунды.',
      'landing.hero.supporting': 'Начните бесплатно · Навыки дизайна не нужны',
      'landing.hero.appStore': 'Загрузить в App Store',
      'landing.hero.googlePlay': 'Доступно в Google Play',
      'landing.hero.scanQr': 'Отсканируйте, чтобы скачать приложение',
      'landing.hero.continueOnWeb': 'Или продолжить в веб-версии',
      'landing.hero.openWebApp': 'Открыть веб-версию',
      'landing.hero.worksInBrowser': 'Работает в браузере',
      'landing.hero.voicePrompt': 'Сделай фото премиальным, добавь 4 500 ₽',
      'landing.hero.priceTag': '4 500 ₽',
      'landing.hero.beforeLabel': 'До',
      'landing.hero.afterLabel': 'После',
      'landing.hero.mockAlt': 'Фото товара до и после обработки в Peckle',
      'terms.title': 'Условия обслуживания',
      'terms.lastUpdated': 'Последнее обновление: {{date}}',
      'privacy.title': 'Политика конфиденциальности',
      'privacy.lastUpdated': 'Последнее обновление: {{date}}',
      'deleteAccount.title': 'Удалить учётную запись',
      'checkout.success.title': 'Оплата прошла успешно',
      'checkout.success.message': 'Спасибо! Платёж выполнен. Кредиты появятся в приложении Peckle через мгновение.',
      'checkout.success.closeHint': 'Можно закрыть это окно и вернуться в приложение.',
      'referral.badge': 'Подарок от друга',
      'referral.headline': 'Получите {{days}} дней фото товаров без водяного знака',
      'referral.subheadline': 'Скачайте Peckle и используйте код друга — вы оба получите изображения без водяного знака.',
      'referral.codeLabel': 'Ваш код приглашения',
      'referral.copy': 'Копировать',
      'referral.copied': 'Скопировано!',
      'referral.manualHint': 'На iPhone: установите Peckle, откройте Настройки → Ввести реферальный код и вставьте этот код.',
      'referral.invalidHeadline': 'Похоже, эта ссылка-приглашение недействительна',
      'referral.invalidSubheadline': 'Вы всё равно можете бесплатно установить Peckle и создавать фото товаров за секунды.',
      'footer.copyright': '© {{year}} Peckle. Все права защищены.',
      'footer.disclaimer': 'Peckle не связан с WhatsApp, Instagram, Facebook или TikTok. Все товарные знаки принадлежат их владельцам.',
      'footer.terms': 'Условия',
      'footer.privacy': 'Конфиденциальность',
    },
  },
  zh: {
    translation: {
      'landing.category': '商品广告制作工具',
      'landing.hero.headline': '适合帖子、快拍和广告的精美商品图。',
      'landing.hero.subheadline': '拍张照片，说出要求，几秒生成吸睛帖子。',
      'landing.hero.supporting': '免费开始 · 无需设计技能',
      'landing.hero.appStore': '在 App Store 下载',
      'landing.hero.googlePlay': '在 Google Play 获取',
      'landing.hero.scanQr': '扫码下载应用',
      'landing.hero.continueOnWeb': '或继续使用网页版',
      'landing.hero.openWebApp': '打开网页版',
      'landing.hero.worksInBrowser': '在浏览器中即可使用',
      'landing.hero.voicePrompt': '让它更有高级感，加上 ¥328',
      'landing.hero.priceTag': '¥328',
      'landing.hero.beforeLabel': '原图',
      'landing.hero.afterLabel': '之后',
      'landing.hero.mockAlt': 'Peckle 制作的商品图前后对比',
      'terms.title': '服务条款',
      'terms.lastUpdated': '最后更新: {{date}}',
      'privacy.title': '隐私政策',
      'privacy.lastUpdated': '最后更新: {{date}}',
      'deleteAccount.title': '删除您的账户',
      'checkout.success.title': '支付成功',
      'checkout.success.message': '谢谢！您的付款已完成。积分稍后将显示在 Peckle 应用中。',
      'checkout.success.closeHint': '您可以关闭此窗口并返回应用。',
      'referral.badge': '来自好友的礼物',
      'referral.headline': '获得 {{days}} 天无水印商品照片',
      'referral.subheadline': '下载 Peckle 并使用好友的邀请码，你们双方都能解锁无水印图片。',
      'referral.codeLabel': '你的邀请码',
      'referral.copy': '复制',
      'referral.copied': '已复制！',
      'referral.manualHint': 'iPhone 用户：安装 Peckle 后，打开设置 → 输入邀请码，粘贴此邀请码。',
      'referral.invalidHeadline': '此邀请链接似乎无效',
      'referral.invalidSubheadline': '你仍然可以免费获取 Peckle，几秒内制作商品照片。',
      'footer.copyright': '© {{year}} Peckle. 保留所有权利。',
      'footer.disclaimer': 'Peckle 与 WhatsApp、Instagram、Facebook 或 TikTok 无关联。所有商标归其各自所有者所有。',
      'footer.terms': '条款',
      'footer.privacy': '隐私',
    },
  },
};

// Languages offered in the site's language selector. Codes must match the
// `resources` keys; native names are shown untranslated, as is convention.
export const supportedLanguages: { code: keyof typeof resources; label: string }[] = [
  { code: 'en', label: 'English' },
  { code: 'pt', label: 'Português (BR)' },
  { code: 'hi', label: 'हिन्दी' },
  { code: 'es', label: 'Español' },
  { code: 'fr', label: 'Français' },
  { code: 'de', label: 'Deutsch' },
  { code: 'ja', label: '日本語' },
  { code: 'ru', label: 'Русский' },
  { code: 'zh', label: '中文' },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    // Resolve regional variants (pt-BR, hi-IN, zh-CN, ...) to our base codes.
    nonExplicitSupportedLngs: true,
    supportedLngs: Object.keys(resources),
    interpolation: { escapeValue: false },
    detection: {
      // localStorage first so a manual choice from the language selector
      // outlives the session and beats the browser locale.
      order: ['localStorage', 'navigator', 'sessionStorage', 'htmlTag'],
      caches: ['localStorage'],
    },
  });

// Keep <html lang> in sync for accessibility, SEO, and font selection
// (matters for CJK/Devanagari rendering).
i18n.on('languageChanged', (lng) => {
  if (typeof document !== 'undefined') document.documentElement.lang = lng;
});
if (typeof document !== 'undefined' && i18n.resolvedLanguage) {
  document.documentElement.lang = i18n.resolvedLanguage;
}

export default i18n;
